export const componentNames = {
	uploadFile: 'uploadFile',
	importRules: 'importRules',
	fieldsMapping: 'fieldsMapping',
	resultStatistic: 'resultStatistic',
};

export const ASSET_ID_SYSTEM_FIELD_NAME = 'assetId';

export const REFETCH_STATISTICS_INTERVAL = 2000;

export const DELAY_FOR_SCROLLING = 200;
